import Vec2D from './Vec2d';
import { Vector2, Vector3 } from 'three';
import * as THREE from 'three';

export class Asteroid {
	constructor(model) {
		this.radius = 1;
		this.color;
		this.pos = new Vector3(0, 0, 0);
		this.vel = new Vector3(0, 0, 0);
		this.scale = 3 + Math.random() * 1;
		this.blacklisted = false;
		this.type = '';
		this.sides = 12;
		this.angle = 0;
		this.angleVel = Math.random() * 2;
		this.rotation = Math.random() * 0.06 + 0.005;
		this.health = 50;
		this.score = 0;
		this.dammage = 10;
		this.seed = Math.floor(Math.random() * 11);
		this.shootSound = new Audio('/assets/sounds/asteroid_explosion.mp3');

		/* const geometry = new THREE.BoxGeometry(1, 1, 1);
		const material = new THREE.MeshLambertMaterial({ color: 0xff0 });
		this.cube = new THREE.Mesh(geometry, material);
		this.cube.scale.set(0.7, 0.7, 0.7); */
		this.mesh;
		this.astBox;

		return this;
	}

	highlight() {
		this.mesh.material.color.set(0xff0000);

		setTimeout(() => {
			this.mesh.material.color.set(this.color);
		}, 50);
	}

	update() {
		// CRITICAL: When using GameCore, position is synced from GameCore, not updated here
		// Check if this asteroid is managed by GameCore (has gameCoreId)
		if (this.gameCoreId !== undefined) {
			// Only rotate the mesh, don't update position (position comes from GameCore)
			this.mesh.rotateX(this.rotation);
			this.mesh.updateMatrix();
			this.mesh.updateMatrixWorld();
			return;
		}
		
		// Original logic for non-GameCore asteroids
		this.pos = this.pos.clone().add(this.vel);
		this.mesh.rotateX(this.rotation);
		this.mesh.position.copy(this.pos);

		this.mesh.updateMatrix();
		this.mesh.updateMatrixWorld();
	}

	playDestroy() {
		//this.shootSound.cloneNode(true).play();
	}

	reset() {
		this.blacklisted = false;
	}
}
